export default __webpack_public_path__ + "static/media/undraw_Preferences_re_49in.d35b29da.png";